module.exports = __webpack_public_path__ + "d89aba23302b4e1b64bafa9deb9e12b9.png";


//////////////////
// WEBPACK FOOTER
// ./shared/components/Logo/assets/blue/efrdxv.png
// module id = 2669
// module chunks = 0